// components/lamaritutka.js

import React, { useEffect, useState } from 'react';
import { getDatabase, ref, set, onValue } from 'firebase/database';

const GameChanger = ({ isAdmin }) => {
  const [u7Data, setU7Data] = useState([]);
  const [u8Data, setU8Data] = useState([]);

  const [newU7Entry, setNewU7Entry] = useState({ player: '', jersey: '', team: '', point: '' });
  const [newU8Entry, setNewU8Entry] = useState({ player: '', jersey: '', team: '', point: '' });

  const [editingU7Entry, setEditingU7Entry] = useState(null);
  const [editingU8Entry, setEditingU8Entry] = useState(null);

  const tabs = ['U7 Ikäluokka', 'U8 Ikäluokka'];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  useEffect(() => {
    const db = getDatabase();
    const u7Ref = ref(db, 'gamechanger/lauantai/u7');
    const u8Ref = ref(db, 'gamechanger/lauantai/u8');

    const unsubU7 = onValue(u7Ref, (snapshot) => setU7Data(snapshot.val() || []));
    const unsubU8 = onValue(u8Ref, (snapshot) => setU8Data(snapshot.val() || []));

    return () => {
      unsubU7();
      unsubU8();
    };
  }, []);

  const addU7Entry = () => {
    if (!newU7Entry.player || !newU7Entry.jersey || !newU7Entry.team || !newU7Entry.point) return;

    const db = getDatabase();
    const refU7 = ref(db, 'gamechanger/lauantai/u7');

    onValue(refU7, (snapshot) => {
      const existing = snapshot.val() || [];
      const updated = [...existing, { ...newU7Entry, point: parseInt(newU7Entry.point) }];
      set(refU7, updated);
      setNewU7Entry({ player: '', jersey: '', team: '', point: '' });
    }, { onlyOnce: true });
  };

  const saveU7Edit = () => {
    const db = getDatabase();
    const refU7 = ref(db, 'gamechanger/lauantai/u7');

    onValue(refU7, (snapshot) => {
      const existing = snapshot.val() || [];
      const updated = existing.map((entry) =>
        entry === editingU7Entry ? { ...newU7Entry, point: parseInt(newU7Entry.point) } : entry
      );
      set(refU7, updated);
      setEditingU7Entry(null);
      setNewU7Entry({ player: '', jersey: '', team: '', point: '' });
    }, { onlyOnce: true });
  };

  const addU8Entry = () => {
    if (!newU8Entry.player || !newU8Entry.jersey || !newU8Entry.team || !newU8Entry.point) return;

    const db = getDatabase();
    const refU8 = ref(db, 'gamechanger/lauantai/u8');

    onValue(refU8, (snapshot) => {
      const existing = snapshot.val() || [];
      const updated = [...existing, { ...newU8Entry, point: parseInt(newU8Entry.point) }];
      set(refU8, updated);
      setNewU8Entry({ player: '', jersey: '', team: '', point: '' });
    }, { onlyOnce: true });
  };

  const saveU8Edit = () => {
    const db = getDatabase();
    const refU8 = ref(db, 'gamechanger/lauantai/u8');

    onValue(refU8, (snapshot) => {
      const existing = snapshot.val() || [];
      const updated = existing.map((entry) =>
        entry === editingU8Entry ? { ...newU8Entry, point: parseInt(newU8Entry.point) } : entry
      );
      set(refU8, updated);
      setEditingU8Entry(null);
      setNewU8Entry({ player: '', jersey: '', team: '', point: '' });
    }, { onlyOnce: true });
  };

  const renderTable = (label, data, isU7 = true) => {
    const sorted = [...data].sort((a, b) => b.point - a.point).slice(0, 5);
  
    return (
      <div style={{ marginBottom: 40 }}>
        <h3>{label} Ikäluokka | Top 5</h3>
        <div className="ranking-table-lämäritutka-container">
          <table className="ranking-table-lämäritutka">
            <thead>
              <tr>
                <th>Sija</th>
                <th>Pelaaja</th>
                <th>Pelinro</th>
                <th>Joukkue</th>
                <th>Pisteet</th>
                {isAdmin && <th></th>}
              </tr>
            </thead>
            <tbody>
              {sorted.length === 0 ? (
                <tr><td colSpan={isAdmin ? 6 : 5}>Ei vielä tuloksia, ole ensimäinen!</td></tr>
              ) : (
                sorted.map((entry, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{entry.player}</td>
                    <td>{entry.jersey}</td>
                    <td>{entry.team}</td>
                    <td>{entry.point}</td>
                    {isAdmin && (
                      <td>
                        <button
                          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 }}
                          onClick={() => {
                            if (isU7) {
                              setEditingU7Entry(entry);
                              setNewU7Entry(entry);
                            } else {
                              setEditingU8Entry(entry);
                              setNewU8Entry(entry);
                            }
                          }}
                        >
                          ✏️
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  
  return (
    <div className="lamaritutka-wrapper">
  <h4 className="date-title">Lauantai 17.05.2025</h4>
  <hr />
  <h3> 🏒 Oletko kentän taitavin? 🏒 </h3>
  <p style={{fontSize: '16px', paddingLeft:'12px', fontWeight:'700'}}>Haasta kiekonkäsittelytaitosi! 🔥</p>
  <p style={{fontSize: '16px', paddingLeft:'12px'}}>2€/kerta tai 3 yritystä 5€. Paras tulos jää taulukkoon!</p>
<p style={{fontSize: '16px',paddingLeft:'12px'}}>Kolme parasta voittaa <strong>yllätyspalkinnon!</strong> 🎁</p>

 {/* Tabs */}
      <div className="tab-container">
        <div
          className="highlight-slider"
          style={{
            transform: activeTab === tabs[0] ? 'translateX(0%)' : 'translateX(100%)',
          }}
        />
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`U8-lohko-tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
{/* Content based on active tab */}
  {activeTab === 'U7 Ikäluokka' && (
        <>
  {isAdmin && (
  <div className="lamaritutka-admin-form">
    <hr/>
    <h4 className="lamaritutka-form-title"> U7 Ikäluokka | {editingU7Entry ? 'Muokkaa tulosta' : 'Lisää uusi tulos'}</h4>
    <div className="lamaritutka-input-row">
      <input
        className="lamaritutka-input"
        placeholder="Pelaaja"
        value={newU7Entry.player}
        onChange={(e) => setNewU7Entry({ ...newU7Entry, player: e.target.value })}
      />
      <input
        className="lamaritutka-input"
        placeholder="Pelinro"
        value={newU7Entry.jersey}
        onChange={(e) => setNewU7Entry({ ...newU7Entry, jersey: e.target.value })}
      />
    </div>
    <div className="lamaritutka-input-row">
      <input
        className="lamaritutka-input"
        placeholder="Joukkue"
        value={newU7Entry.team}
        onChange={(e) => setNewU7Entry({ ...newU7Entry, team: e.target.value })}
      />
      <input
        className="lamaritutka-input"
        type="number"
        placeholder="Pisteet"
        value={newU7Entry.point}
        onChange={(e) => setNewU7Entry({ ...newU7Entry, point: e.target.value })}
      />
    </div>
    <button className="lamaritutka-button" onClick={editingU7Entry ? saveU7Edit : addU7Entry}>
      {editingU7Entry ? 'Tallenna' : 'Lisää'}
    </button>
  </div>
)}

{renderTable('U7', u7Data, true)}
</>
)}
{activeTab === 'U8 Ikäluokka' && (
        <>
{isAdmin && (
    
  <div className="lamaritutka-admin-form">
    <hr/>
    <h4 className="lamaritutka-form-title">U8 Ikäluokka | {editingU8Entry ? 'Muokkaa tulosta' : 'Lisää uusi tulos'}</h4>
    <div className="lamaritutka-input-row">
      <input
        className="lamaritutka-input"
        placeholder="Pelaaja"
        value={newU8Entry.player}
        onChange={(e) => setNewU8Entry({ ...newU8Entry, player: e.target.value })}
      />
      <input
        className="lamaritutka-input"
        placeholder="Pelinro"
        value={newU8Entry.jersey}
        onChange={(e) => setNewU8Entry({ ...newU8Entry, jersey: e.target.value })}
      />
    </div>
    <div className="lamaritutka-input-row">
      <input
        className="lamaritutka-input"
        placeholder="Joukkue"
        value={newU8Entry.team}
        onChange={(e) => setNewU8Entry({ ...newU8Entry, team: e.target.value })}
      />
      <input
        className="lamaritutka-input"
        type="number"
        placeholder="Pisteet"
        value={newU8Entry.point}
        onChange={(e) => setNewU8Entry({ ...newU8Entry, point: e.target.value })}
      />
    </div>
    <button className="lamaritutka-button" onClick={editingU8Entry ? saveU8Edit : addU8Entry}>
      {editingU8Entry ? 'Tallenna' : 'Lisää'}
    </button>
  </div>
)}

{renderTable('U8', u8Data, true)}
</>
)}
</div>

  );
  
  
};

export default GameChanger;
